<p>{{ 'components.updateAppDialog.labels.title' | translate }}</p>

<div class="buttons">
  <app-mobile-app-download-links
    *ngIf="env.isIosWithCordova || env.isAndroidWithCordova; else buttonLinkTmp"
    class="mobile-app-download-links"
    [appStoreLink]="env.isIosWithCordova ? appConfig?.appStoreLink : undefined"
    [googlePlayLink]="env.isAndroidWithCordova ? appConfig?.googlePlayLink : undefined"
    [ruStoreLink]="env.isAndroidWithCordova ? appConfig?.ruStoreLink : undefined"
  ></app-mobile-app-download-links>

  <ng-template #buttonLinkTmp>
    <button tuiButton type="button" [size]="tuiElementMediumSize" (click)="reload()">
      {{ 'common.buttons.update' | translate }}
    </button>
  </ng-template>
</div>
